import { db } from "../firebase";
import { doc, getDoc } from "firebase/firestore";

export const AuthorizationService = {
  async canAccessCampaign(userId, campaignId) {
    try {
      const userDoc = await getDoc(doc(db, "users", userId));
      if (!userDoc.exists()) {
        return false;
      }

      const userData = userDoc.data();

      if (userData.campaigns?.includes(campaignId)) {
        return true;
      }

      // Check if user is an agent in this campaign
      const agentDoc = await getDoc(
        doc(db, `campaigns/${campaignId}/agents`, userId)
      );
      if (agentDoc.exists()) {
        return true;
      }

      return false;
    } catch (error) {
      console.error("Error checking campaign access:", error);
      return false;
    }
  },

  async canAccessOrganization(userId, organizationId) {
    try {
      const userDoc = await getDoc(doc(db, "users", userId));
      if (!userDoc.exists()) {
        return false;
      }

      const userData = userDoc.data();
      // Check if organizationId exists in the user's organizations array
      return userData.organizations?.includes(organizationId) || false;
    } catch (error) {
      console.error("Error checking organization access:", error);
      return false;
    }
  },
};
